import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39aab3d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "price-tag-modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Skriv ut prislapp", -1))
const _hoisted_3 = { for: "printPriceTagSize" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Størrelse", -1))
const _hoisted_5 = { for: "printPriceTagPrice" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Pris", -1))
const _hoisted_7 = { for: "printPriceTagAmount" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Antall", -1))
const _hoisted_9 = {
  key: 0,
  class: "price-tag-modal__custom-text"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "printPriceTagsCustomText",
  class: "label"
}, "Ekstra tekst", -1))
const _hoisted_11 = { class: "price-tag-modal__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ValidationFormErrors = _resolveComponent("ValidationFormErrors")!
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.open)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onDismiss: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('dismiss'))),
        open: _ctx.open
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("header", null, [
              _hoisted_2,
              _createElementVNode("p", null, "Skriv ut prislapp for produkt \"" + _toDisplayString(_ctx.product.name) + "\"", 1)
            ]),
            _createVNode(_component_ValidationFormErrors, {
              errors: _ctx.form.errors
            }, null, 8, ["errors"]),
            _createElementVNode("label", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_ButtonGroup, {
                class: "button-group",
                id: "printPriceTagSize",
                color: "secondary",
                "value-prop": "value",
                options: _ctx.sizeOptions,
                modelValue: _ctx.form.small,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.small) = $event))
              }, {
                default: _withCtx(({ option }) => [
                  _createTextVNode(_toDisplayString(option.label), 1)
                ]),
                _: 1
              }, 8, ["options", "modelValue"])
            ]),
            _createElementVNode("label", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_ButtonGroup, {
                class: "button-group",
                id: "printPriceTagPrice",
                color: "secondary",
                "value-prop": "value",
                options: _ctx.priceOptions,
                modelValue: _ctx.form.priceType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.priceType) = $event))
              }, {
                default: _withCtx(({ option }) => [
                  _createTextVNode(_toDisplayString(option.label), 1)
                ]),
                _: 1
              }, 8, ["options", "modelValue"])
            ]),
            _createElementVNode("label", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_ButtonGroup, {
                class: "button-group",
                id: "printPriceTagAmount",
                color: "secondary",
                "value-prop": "value",
                options: _ctx.amountOptions,
                modelValue: _ctx.form.amount,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.amount) = $event))
              }, {
                default: _withCtx(({ option }) => [
                  _createTextVNode(_toDisplayString(option.label), 1)
                ]),
                _: 1
              }, 8, ["options", "modelValue"])
            ]),
            (_ctx.customTextVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.customText) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.form.customText]
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Button, {
                color: "green",
                onClick: _ctx.submit
              }, {
                default: _withCtx(() => [
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_SvgIcon, {
                        key: 0,
                        type: "mdi",
                        path: _ctx.loadingIcon
                      }, null, 8, ["path"]))
                    : (_openBlock(), _createBlock(_component_SvgIcon, {
                        key: 1,
                        type: "mdi",
                        path: _ctx.printIcon
                      }, null, 8, ["path"])),
                  _createTextVNode(" Skriv ut")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_Button, {
                color: "gray",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('dismiss')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Avbryt")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["open"]))
    : _createCommentVNode("", true)
}